function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { withRouter } from "react-router";
import { DetailContainer } from "../../components/container-activity";
import { BaseDataViewComponent } from "../../components/base";
import publishSearch from '../../functions/publish-search';
import publishEvent from "../../functions/publish-event";
import { MDCTextInput, MDCFileUpload } from '../../../jsx/components/mdc-components';
import { AlertMessage } from '../../ui/alert';
import ProgressSuccess from '../../ui/progress/success';
import endpoints from "../../endpoints";
import account from "../../data/account";
import { manageDataLegacyHere } from "../../functions/tenant-features";
import { downloadTemplate, AUDIENCE_COLUMNS } from "../../functions/csv-templates";
const CONSENT_HEADERS = ['email opt-in', 'email opt in', 'opt-in', 'opt in'];

/** Appends an "Email Opt-In" column with `value` on every record; returns null when the file already carries one. */
export function appendConsentColumn(text, value) {
  if (!text) return null;
  var records = [],
    cur = '',
    inQuotes = false;
  for (var i = 0; i < text.length; i++) {
    var ch = text[i];
    if (ch === '"') {
      inQuotes = !inQuotes;
      cur += ch;
      continue;
    }
    if (!inQuotes && (ch === '\n' || ch === '\r')) {
      if (ch === '\r' && text[i + 1] === '\n') i++;
      records.push(cur);
      cur = '';
      continue;
    }
    cur += ch;
  }
  if (cur.length) records.push(cur);
  if (!records.length) return null;
  var header = records[0].split(',').map(function (h) {
    return h.replace(/^"|"$/g, '').trim().toLowerCase();
  });
  if (header.some(function (h) {
    return CONSENT_HEADERS.indexOf(h) !== -1;
  })) return null;
  var out = [records[0] + ',Email Opt-In'];
  for (var r = 1; r < records.length; r++) {
    if (records[r].trim() === '') {
      out.push(records[r]);
      continue;
    }
    out.push(records[r] + ',' + value);
  }
  return out.join('\r\n') + '\r\n';
}
class MainComponent extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "onChange", event => {
      var target = event.target;
      var value = target.value;
      this.setState({
        audience: value
      });
    });
    _defineProperty(this, "onGoBack", () => {
      this.props.history.goBack();
    });
    _defineProperty(this, "onFocus", event => {
      this.setState({
        showMessage: false,
        messageType: '',
        message: null
      });
    });
    _defineProperty(this, "onDownloadTemplate", event => {
      downloadTemplate("audience_template.csv", AUDIENCE_COLUMNS);
    });
    _defineProperty(this, "onUploadError", obj => {
      this.count = 0;
      this.setState({
        showMessage: true,
        messageType: 'error',
        message: 'Error: Error uploading file.'
      });
    });
    _defineProperty(this, "onUploadComplete", obj => {
      this.count = 0;
      this.setState({
        showSuccess: true,
        showMessage: false,
        messageType: '',
        message: null
      });
    });
    _defineProperty(this, "onUploadProgressComplete", () => {
      this.setState({
        showMessage: true,
        messageType: '',
        message: 'Processing uploaded file.'
      });
    });
    _defineProperty(this, "onBeforeUpload", files => {
      //await Plunk360Service.refreshTokenCheckAsync();
      //
      this.handleUpload(files);
    });
    _defineProperty(this, "handleUpload", files => {
      if (this.count > 0) return false;
      var audience = this.state.audience;
      if (!audience) {
        this.count = 0;
        this.upload.reset();
        this.setState({
          showMessage: true,
          messageType: 'error',
          message: 'Error: Audience Name Required.'
        });
        return false;
      }
      var headers = [{
        key: 'authorization',
        value: ''
      }, {
        key: 'X-APP-ID',
        value: this.state.appId
      }, {
        key: 'X-NAME',
        value: audience
      }];
      this.upload.headers = headers;
      this.count = 1;
      if (this.state.consent === 'opt_out' && files && files.length === 1 && /\.csv$/i.test(files[0].name || '')) {
        var original = files[0];
        var self = this;
        original.text().then(function (text) {
          var rewritten = appendConsentColumn(text, 'no');
          var file = rewritten == null ? original : new File([rewritten], original.name, {
            type: original.type || 'text/csv'
          });
          self.upload.resume([file]);
        }).catch(function () {
          self.upload.resume(files);
        });
        return true;
      }
      this.upload.resume(files);
    });
    _defineProperty(this, "onConsentChange", e => {
      this.setState({
        consent: e.target.value
      });
    });
    _defineProperty(this, "uploadAnother", () => {
      this.count = 0;
      this.setState({
        showSuccess: false,
        showMessage: false,
        message: null,
        messageType: ''
      });
    });
    this.state = this.initState();
  }
  initState() {
    var postUrl = endpoints.audience.root + '/audience/managed';
    var accountData = account.get();
    // "Upload more" on Manage Data › Audiences opens this page with ?name=<list> so the file goes to that list.
    var presetName = '';
    try {
      presetName = new URLSearchParams(window.location.search).get('name') || '';
    } catch (e) {
      presetName = '';
    }
    return {
      audience: presetName,
      showSuccess: false,
      showMessage: false,
      messageType: '',
      message: null,
      postUrl: postUrl,
      appId: accountData.tenantId,
      // Email consent for the people in this file (DS 2026-10-03): imports are opt-in by default; "opt_out" appends an
      // "Email Opt-In = no" column before upload so the importer records the opt-out per row (a column already in the
      // file always wins).
      consent: 'opt_in'
    };
  }
  componentDidMount() {
    this.count = 0;
    publishSearch('Audiences');
    publishEvent('reset-search', {});
  }
  render() {
    if (manageDataLegacyHere()) return this.renderLegacy();
    let preset = '';
    try {
      preset = new URLSearchParams(window.location.search).get('name') || '';
    } catch (e) {
      preset = '';
    }
    const optOut = this.state.consent === 'opt_out';
    return /*#__PURE__*/React.createElement("div", {
      className: "territory-view ec-view ecc-view aup-view"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ecc-top"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "ecc-back",
      "aria-label": "Back",
      onClick: this.onGoBack
    }, /*#__PURE__*/React.createElement("svg", {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      "aria-hidden": "true"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M10 3L5 8l5 5",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.8",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "ecc-titleblock"
    }, /*#__PURE__*/React.createElement("span", {
      className: "aup-title"
    }, preset ? `Add people to ${preset}` : "Upload a list"), /*#__PURE__*/React.createElement("span", {
      className: "ecc-meta"
    }, "People in your file are added to the list. Nobody is emailed.")), /*#__PURE__*/React.createElement("span", {
      className: "ecc-spacer"
    })), this.state.showSuccess ? /*#__PURE__*/React.createElement("section", {
      className: "aup-card aup-done"
    }, /*#__PURE__*/React.createElement("b", null, "Your list is uploading"), /*#__PURE__*/React.createElement("span", null, "People show up in ", this.state.audience || "the list", " within a few minutes. Large files can take longer."), /*#__PURE__*/React.createElement("span", {
      className: "aup-actions"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary",
      onClick: () => this.props.history.push("/Audience")
    }, "Go to your lists"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-base",
      onClick: this.uploadAnother
    }, "Upload another file"))) : /*#__PURE__*/React.createElement("div", {
      className: "aup-steps"
    }, /*#__PURE__*/React.createElement("section", {
      className: "aup-card"
    }, /*#__PURE__*/React.createElement("b", {
      className: "aup-h"
    }, "1 \xB7 Name the list"), /*#__PURE__*/React.createElement("input", {
      className: "aup-input",
      type: "text",
      value: this.state.audience,
      placeholder: "For example: Spring event sign-ups",
      onChange: this.onChange,
      onFocus: this.onFocus,
      disabled: !!preset
    }), preset ? /*#__PURE__*/React.createElement("span", {
      className: "aup-hint"
    }, "New people are added to this existing list.") : null), /*#__PURE__*/React.createElement("section", {
      className: "aup-card"
    }, /*#__PURE__*/React.createElement("div", {
      className: "aup-row"
    }, /*#__PURE__*/React.createElement("b", {
      className: "aup-h"
    }, "2 \xB7 Get your file ready"), /*#__PURE__*/React.createElement("span", {
      className: "ecc-spacer"
    }), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-base",
      onClick: this.onDownloadTemplate
    }, "Download a template")), /*#__PURE__*/React.createElement("span", {
      className: "aup-hint"
    }, "A CSV file with one row per person. An email address or phone number is enough; these columns are used when they're there:"), /*#__PURE__*/React.createElement("div", {
      className: "aup-groups"
    }, MainComponent.GROUPS.map(([g, cols]) => /*#__PURE__*/React.createElement("div", {
      key: g,
      className: "aup-group"
    }, /*#__PURE__*/React.createElement("span", {
      className: "aup-gl"
    }, g), /*#__PURE__*/React.createElement("span", {
      className: "aup-cols"
    }, cols.map(c => /*#__PURE__*/React.createElement("span", {
      key: c,
      className: "aup-col"
    }, c))))))), /*#__PURE__*/React.createElement("section", {
      className: "aup-card"
    }, /*#__PURE__*/React.createElement("b", {
      className: "aup-h"
    }, "3 \xB7 Email permission"), /*#__PURE__*/React.createElement("div", {
      className: "aup-choices"
    }, /*#__PURE__*/React.createElement("label", {
      className: "aup-choice" + (!optOut ? " on" : "")
    }, /*#__PURE__*/React.createElement("input", {
      type: "radio",
      name: "audience-consent",
      value: "opt_in",
      checked: !optOut,
      onChange: this.onConsentChange
    }), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("b", null, "They've agreed to get email"), /*#__PURE__*/React.createElement("span", null, "They can be included in email sends."))), /*#__PURE__*/React.createElement("label", {
      className: "aup-choice" + (optOut ? " on" : "")
    }, /*#__PURE__*/React.createElement("input", {
      type: "radio",
      name: "audience-consent",
      value: "opt_out",
      checked: optOut,
      onChange: this.onConsentChange
    }), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("b", null, "They haven't agreed yet"), /*#__PURE__*/React.createElement("span", null, "They're added to the list, but email sends skip them.")))), /*#__PURE__*/React.createElement("span", {
      className: "aup-hint"
    }, "An \"Email Opt-In\" column in your file decides it for each person instead.")), /*#__PURE__*/React.createElement("section", {
      className: "aup-card"
    }, /*#__PURE__*/React.createElement("b", {
      className: "aup-h"
    }, "4 \xB7 Upload the file"), /*#__PURE__*/React.createElement(MDCFileUpload, {
      cls: "aup-drop",
      singleFileUpload: true,
      postUrl: this.state.postUrl,
      onBeforeUpload: this.onBeforeUpload,
      onUploadError: this.onUploadError,
      onUploadComplete: this.onUploadComplete,
      onUploadProgressComplete: this.onUploadProgressComplete,
      ref: ref => this.upload = ref,
      accept: ".csv"
    }), this.state.showMessage && /*#__PURE__*/React.createElement("div", {
      className: "aup-msg" + (this.state.messageType === 'error' ? " bad" : "")
    }, String(this.state.message || "").replace(/^Error:\s*/, "")))));
  }
  renderLegacy() {
    return /*#__PURE__*/React.createElement(DetailContainer, {
      title: "Create Audience",
      onGoBack: this.onGoBack
    }, this.state.showSuccess ? /*#__PURE__*/React.createElement(ProgressSuccess, {
      message: "Your audience file has been successfully uploaded."
    }) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "medium"
    }, "1. Prepare a File with your Customer Data"), /*#__PURE__*/React.createElement("div", {
      className: "size-14"
    }, "Data types you can use:"), /*#__PURE__*/React.createElement("div", {
      className: "flex-data-types"
    }, AUDIENCE_COLUMNS.map(t => /*#__PURE__*/React.createElement("div", {
      key: t
    }, t))), /*#__PURE__*/React.createElement("a", {
      className: "size-14-hover",
      onClick: this.onDownloadTemplate
    }, "Download Template"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
      className: "medium"
    }, "2. Name"), /*#__PURE__*/React.createElement("div", {
      className: "form-width"
    }, /*#__PURE__*/React.createElement(MDCTextInput, {
      label: "Name your audience",
      value: this.state.audience,
      onChange: this.onChange,
      onFocus: this.onFocus
    })), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
      className: "medium"
    }, "3. Email consent"), /*#__PURE__*/React.createElement("div", {
      className: "audience-consent-choice"
    }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("input", {
      type: "radio",
      name: "audience-consent",
      value: "opt_in",
      checked: this.state.consent !== 'opt_out',
      onChange: this.onConsentChange
    }), " These contacts have opted in to email (default)"), /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("input", {
      type: "radio",
      name: "audience-consent",
      value: "opt_out",
      checked: this.state.consent === 'opt_out',
      onChange: this.onConsentChange
    }), " They have not opted in (record them as opted out; bulk email will skip them)"), /*#__PURE__*/React.createElement("div", {
      className: "hint"
    }, "A column named \"Email Opt-In\" in the file overrides this choice row by row.")), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
      className: "medium"
    }, "4. Add Your File"), /*#__PURE__*/React.createElement(MDCFileUpload, {
      singleFileUpload: true,
      postUrl: this.state.postUrl,
      onBeforeUpload: this.onBeforeUpload,
      onUploadError: this.onUploadError,
      onUploadComplete: this.onUploadComplete,
      onUploadProgressComplete: this.onUploadProgressComplete,
      ref: ref => this.upload = ref,
      accept: ".csv"
    }), this.state.showMessage && /*#__PURE__*/React.createElement(AlertMessage, {
      message: this.state.message,
      cls: this.state.messageType
    })), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null));
  }
}
// Column groups for the "get your file ready" step: the exact header names the importer matches
// (lowercase, as in the template; "Email" or "email" alone is not read).
_defineProperty(MainComponent, "GROUPS", [["Contact", ["email address", "phone number", "first name", "last name"]], ["Address", ["street address", "street address 2", "city", "region", "postal code", "country", "metro", "continent", "geo"]], ["About them", ["gender", "date of birth", "age", "age range", "ethnicity", "race", "household income", "household size", "has children", "has senior", "household language"]], ["Your own ID", ["customer id"]], ["Consent", ["email opt-in", "opt-in date", "opt-in source"]]]);
export class AudienceCreateViewComponent extends BaseDataViewComponent {
  constructor(props) {
    super(props);
  }
  fetchData() {
    setTimeout(() => {
      this.allowRender = true;
      this.data = {};
      this.forceUpdate();
    }, 100);
  }
  render() {
    if (!this.allowRender) {
      return null;
    } else {
      return /*#__PURE__*/React.createElement(RoutableComponent, {
        data: this.data,
        params: this.props.params
      });
    }
  }
}
const RoutableComponent = withRouter(MainComponent);
export default {
  AudienceCreateViewComponent
};